import { render, staticRenderFns } from "./ProductTagsComponent.vue?vue&type=template&id=1bba5082&"
import script from "./ProductTagsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductTagsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports